import { render, staticRenderFns } from "./ActivateStorageLocation.vue?vue&type=template&id=45bca8c3"
import script from "./ActivateStorageLocation.vue?vue&type=script&lang=js"
export * from "./ActivateStorageLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports